export const ELEMENTS_DESIGN_SECTION = {
  EDIT_ELEMENT_NAME_TOOLTIP: { key: 'EDIT_ELEMENT_NAME_TOOLTIP', value: 'Edit Element Name' },
  UNTITLED_ELEMENT_NAME: { key: 'UNTITLED_ELEMENT_NAME', value: 'untitled' },
  ELEMENT_NAME_PLACEHOLDER: { key: 'ELEMENT_NAME_PLACEHOLDER', value: 'Name your element' },
  CLOSE_SIDEBAR_SETTINGS_PANEL_TOOLTIP: {
    key: 'CLOSE_SIDEBAR_SETTINGS_PANEL_TOOLTIP',
    value: 'Close settings',
  },
  CLOSE_SIDEBAR_LAYOUT_PANEL_TOOLTIP: {
    key: 'CLOSE_SIDEBAR_LAYOUT_PANEL_TOOLTIP',
    value: 'Close layout panel',
  },
  SHOW_SIDEBAR_LAYOUT_PANEL_TOOLTIP: {
    key: 'SHOW_SIDEBAR_LAYOUT_PANEL_TOOLTIP',
    value: 'Show layout panel',
  },
  CLOSE_SIDEBAR_FONT_PANEL_TOOLTIP: {
    key: 'CLOSE_SIDEBAR_FONT_PANEL_TOOLTIP',
    value: 'Close font panel',
  },
};
